import React from 'react';
import { Alert } from '@mui/material';

export const NOT_IN_CHARGE_MESSAGE =
    'You are not in charge of any store yet. Ask your store head or admin to add you as in charge of a store.';

/**
 * Friendly empty state for a Store Manager / Store Staff who is in charge of no store (they see only the
 * stores they are in charge of). Render it when the store list has loaded and is empty.
 */
const NotInChargeNotice: React.FC = () => (
    <Alert severity="info" sx={{ mb: 2 }} data-testid="not-in-charge-notice" data-help="store.scope.notInCharge">
        {NOT_IN_CHARGE_MESSAGE}
    </Alert>
);

export default NotInChargeNotice;
